import GeneralTracker from '../GeneralTracker';


export interface TransactionCompletePayload {
  location: string;
  api: string;
  testTransaction: boolean;
  operationStatus: string;
  errorCode: string | null;
  purchaseId: string;
  processorId: number | bigint;
  total: number | bigint;
  paymentInformation: {
    type: string | null;
    subtype: string | null;
  };
  items: {
    id: string;
    name: string;
    category: string;
    quantity: number | bigint;
    price: number | bigint;
    currency: 'USD' | 'EUR' | string;
    bonus: number | bigint | null;
    fee: number | bigint | null;
  }[];
}

export type TransactionCompleteHandler = (payload: TransactionCompletePayload) => Promise<void> | void;

export class EcommercePaymentTracker extends GeneralTracker {
  public readonly CAPTURE_NAME = 'snowplow:ecommerce';
  public readonly STORAGE_KEY = 'trackingEcommercePayment';
  public readonly VERSION = '1';

  public setHandlers(): void {
    const service = this.getService();
    service.on('ecommerceTransactionComplete', this.onTransactionComplete);
  }

  private readonly onTransactionComplete: TransactionCompleteHandler =
    (payload: TransactionCompletePayload): void => {
      this.track({
        action: 'transactionComplete',
        tag: { ...payload },
      });
    };

}

export default EcommercePaymentTracker;
